/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getQueuesResources,
	getQueueConfigResource,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { issueListSsrResource } from '@jira/router-resources__service-desk-queues/src/queuesNavigationItems.tsx';
import { servicedeskQueuesEditRoute } from '@jira/router-routes__servicedesk-queues-routes/src/servicedeskQueuesEditRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { ServicedeskQueuesConfig, LazyServicedeskQueuesConfig } from './ui/queues-config/index.tsx';
import { serviceDeskQueuesConfigPageEntryPoint } from './ui/queues-config-page-entry-point/index.tsx';

export const servicedeskQueuesEditRouteEntry: Route = createEntry(
	servicedeskQueuesEditRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServicedeskQueuesConfig,
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
		},
		resources: [
			issueListSsrResource,
			...getQueuesResources(),
			getConsolidationStateResource(),
			...getQueueConfigResource(),
		],
		forPaint: [LazyAtlassianNavigation, LazyServicedeskQueuesConfig],
		ufoName: 'service-management.queues.edit',
		pageId: ({ query }) => `spa-apps/servicedesk/queues/views-config/${query.config}`,
		entryPoint() {
			return serviceDeskQueuesConfigPageEntryPoint;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
